import React from 'react';
import { useStore } from 'effector-react';
import { ImageType } from '@types';
import Button from '@components/Button';
import Image from '@components/Image';
import { MapCaptureGate } from '@stores/editingMarkerStores';
import onMapCaptureClick from '../actions/onMapCaptureClick';

function MapCaptureWidget() {
  const isOn = useStore(MapCaptureGate.state);
  if (!isOn) return null;
  return (
    <>
      <Image
        className="pointer-events-none absolute"
        src="/imgs/map-capture.14f69ffa28efacea7ec8a8b773ec5c69.png"
        type={ImageType.sysMedia}
      />
      <Button className="absolute mt-300" onClick={() => onMapCaptureClick()}>
        把当前区域设为初始区域
      </Button>
    </>
  );
}

export default MapCaptureWidget;
